<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm"
>
  <div class="bg-white rounded-xl shadow-xl w-full max-w-4xl">
    <div class="flex items-center justify-between px-6 pt-4 border-gray-200">
      <div class="flex items-center gap-4">
        <h2 class="text-xl font-semibold text-gray-800">
          Health Declaration for {{ member.name }}
        </h2>
      </div>
      <button
        (click)="onClose()"
        class="text-gray-500 hover:text-gray-700 focus:outline-none"
        aria-label="Close"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div
      class="p-6 border-b pt-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-gray-600 text-sm"
    >
      <div class="flex items-center gap-1">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1019_6151)">
            <path
              d="M6.66699 10.6668H9.33366M5.86699 14.6668H10.1337C11.2538 14.6668 11.8138 14.6668 12.2416 14.4488C12.618 14.2571 12.9239 13.9511 13.1157 13.5748C13.3337 13.147 13.3337 12.5869 13.3337 11.4668V4.5335C13.3337 3.41339 13.3337 2.85334 13.1157 2.42552C12.9239 2.04919 12.618 1.74323 12.2416 1.55148C11.8138 1.3335 11.2538 1.3335 10.1337 1.3335H5.86699C4.74689 1.3335 4.18683 1.3335 3.75901 1.55148C3.38269 1.74323 3.07673 2.04919 2.88498 2.42552C2.66699 2.85334 2.66699 3.41339 2.66699 4.5335V11.4668C2.66699 12.5869 2.66699 13.147 2.88498 13.5748C3.07673 13.9511 3.38269 14.2571 3.75901 14.4488C4.18683 14.6668 4.74689 14.6668 5.86699 14.6668ZM10.0003 6.00016C10.0003 7.10473 9.10489 8.00016 8.00033 8.00016C6.89576 8.00016 6.00033 7.10473 6.00033 6.00016C6.00033 4.89559 6.89576 4.00016 8.00033 4.00016C9.10489 4.00016 10.0003 4.89559 10.0003 6.00016Z"
              stroke="#5A6374"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1019_6151">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <span>{{ member.idNumber }}</span>
      </div>
      <div class="flex items-center gap-1">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 6.66683H2M10.6667 1.3335V4.00016M5.33333 1.3335V4.00016M5.2 14.6668H10.8C11.9201 14.6668 12.4802 14.6668 12.908 14.4488C13.2843 14.2571 13.5903 13.9511 13.782 13.5748C14 13.147 14 12.5869 14 11.4668V5.86683C14 4.74672 14 4.18667 13.782 3.75885C13.5903 3.38252 13.2843 3.07656 12.908 2.88482C12.4802 2.66683 11.9201 2.66683 10.8 2.66683H5.2C4.0799 2.66683 3.51984 2.66683 3.09202 2.88482C2.71569 3.07656 2.40973 3.38252 2.21799 3.75885C2 4.18667 2 4.74672 2 5.86683V11.4668C2 12.5869 2 13.147 2.21799 13.5748C2.40973 13.9511 2.71569 14.2571 3.09202 14.4488C3.51984 14.6668 4.0799 14.6668 5.2 14.6668Z"
            stroke="#5A6374"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <span>{{ member.dob }}</span>
      </div>
      <span
        class="border border-[#0C2964] text-[#0C2964] text-md rounded-md px-2"
        >{{ member.type }}</span
      >
    </div>

    <div class="p-6 space-y-6 max-h-[70vh] overflow-y-auto">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div>
          <label
            for="weight"
            class="block text-gray-700 text-base font-medium mb-2"
            >Weight</label
          >
          <div class="flex rounded-lg shadow-sm border border-gray-300">
            <input
              type="number"
              id="weight"
              name="weight"
              placeholder="Enter weight"
              [(ngModel)]="weight"
              class="block w-full p-3 border-0 rounded-l-lg focus:ring-0 bg-white"
              min="0"
            />
            <span
              class="inline-flex items-center px-4 text-gray-500 bg-gray-50 border-l border-gray-300 rounded-r-lg"
              >kg</span
            >
          </div>
        </div>
        <div>
          <label
            for="height"
            class="block text-gray-700 text-base font-medium mb-2"
            >Height</label
          >
          <div class="flex rounded-lg shadow-sm border border-gray-300">
            <input
              type="number"
              id="height"
              name="height"
              placeholder="Enter height"
              [(ngModel)]="height"
              class="block w-full p-3 border-0 rounded-l-lg focus:ring-0 bg-white"
              min="0"
            />
            <span
              class="inline-flex items-center px-4 text-gray-500 bg-gray-50 border-l border-gray-300 rounded-r-lg"
              >cm</span
            >
          </div>
        </div>
      </div>

      <div class="space-y-4">
        <div class="p-4 border rounded-xl border-gray-200 bg-white">
          <div
            class="flex items-center cursor-pointer"
            (click)="onHospitalizationToggle()"
          >
            <label class="text-gray-700 text-base font-medium flex-grow pr-4">
              {{ hospitalizationLabel }}
            </label>
            <div
              class="relative inline-flex items-center h-6 rounded-full transition-colors duration-300 ease-in-out"
              [ngClass]="
                hospitalization
                  ? 'bg-blue-600 justify-end'
                  : 'bg-gray-200 justify-start'
              "
              style="width: 56px"
            >
              <!-- Switch Knob -->
              <span
                class="absolute w-3 h-3 bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out"
                [ngClass]="
                  hospitalization ? 'translate-x-7 left-1' : 'translate-x-1'
                "
              ></span>

              <!-- Labels container -->
              <div class="flex w-full items-center justify-between px-1.5">
                <!-- Label: YES -->
                <span
                  class="text-white text-xs font-semibold transition-opacity duration-200 ease-in-out"
                  [ngClass]="hospitalization ? 'opacity-100' : 'opacity-0'"
                >
                  Yes
                </span>

                <!-- Label: NO -->
                <span
                  class="text-gray-700 text-xs font-semibold transition-opacity duration-200 ease-in-out"
                  [ngClass]="!hospitalization ? 'opacity-100' : 'opacity-0'"
                >
                  No
                </span>
              </div>
            </div>
          </div>
          <div
            *ngIf="hospitalization"
            class="flex justify-between items-center mb-4"
          >
            <div class="w-[50%] mr-2 p-2">
              <label
                for="question-details-hospitalization-count"
                class="block text-gray-700 text-sm font-medium mb-2"
                >How many times?</label
              >
              <div class="flex rounded-lg shadow-sm border border-gray-300">
                <input
                  type="number"
                  id="frequency"
                  name="frequency"
                  placeholder="Select frequency"
                  [(ngModel)]="hospitalizationCount"
                  class="block w-full p-3 border-0 rounded-lg focus:ring-0 bg-white"
                  min="0"
                />
              </div>
            </div>
            <div class="w-[50%] mx-2 p-1">
              <label
                for="height"
                class="block text-gray-700 text-base font-medium mb-2"
                >Reason?</label
              >

              <select
                id="question-details-hospitalization-reason"
                [(ngModel)]="hospitalizationReason"
                class="block w-full p-3 border border-gray-300 rounded-lg"
              >
                <option [ngValue]="null" disabled>Select reason</option>
                <option
                  *ngFor="
                    let reason of [
                      'Fever',
                      'Cold',
                      'Diabetes',
                      'Normal checkup',
                      'Other'
                    ]
                  "
                  [ngValue]="reason"
                >
                  {{ reason }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div *ngFor="let question of healthQuestions; let i = index">
          <div class="p-4 border rounded-xl border-gray-200 bg-white">
            <div
              class="flex items-center cursor-pointer"
              (click)="onMainToggleChange(question)"
            >
              <label class="text-gray-700 text-base font-medium flex-grow pr-4">
                {{ question.label }}
              </label>
              <div
                class="relative inline-flex items-center h-6 rounded-full transition-colors duration-300 ease-in-out"
                [ngClass]="
                  question.selected
                    ? 'bg-blue-600 justify-end'
                    : 'bg-gray-200 justify-start'
                "
                style="width: 56px"
              >
                <!-- Switch Knob -->
                <span
                  class="absolute w-3 h-3 bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out"
                  [ngClass]="
                    question.selected ? 'translate-x-7 left-1' : 'translate-x-1'
                  "
                ></span>

                <!-- Labels container -->
                <div class="flex w-full items-center justify-between px-1.5">
                  <!-- Label: YES -->
                  <span
                    class="text-white text-xs font-semibold transition-opacity duration-200 ease-in-out"
                    [ngClass]="question.selected ? 'opacity-100' : 'opacity-0'"
                  >
                    Yes
                  </span>

                  <!-- Label: NO -->
                  <span
                    class="text-gray-700 text-xs font-semibold transition-opacity duration-200 ease-in-out"
                    [ngClass]="!question.selected ? 'opacity-100' : 'opacity-0'"
                  >
                    No
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="question.selected" class="mt-4 pt-4 border-gray-200">
              <div
                *ngIf="
                  question.type === 'disease-selection' && question.conditions
                "
              >
                <div
                  class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-4 gap-x-3"
                >
                  <div
                    class="border rounded-lg p-3"
                    *ngFor="let condition of question.conditions"
                  >
                    <label class="flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        class="sr-only"
                        [checked]="condition.selected"
                        (change)="onConditionToggle(condition)"
                      />
                      <span
                        class="w-4 h-4 flex items-center justify-center border rounded"
                        [ngClass]="
                          condition.selected
                            ? 'bg-blue-600 border-blue-600'
                            : 'bg-white border-gray-400'
                        "
                      >
                        <svg
                          *ngIf="condition.selected"
                          class="w-2 h-2 text-white fill-current"
                          viewBox="0 0 20 20"
                        >
                          <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                        </svg>
                      </span>
                      <span class="ml-2 text-sm text-gray-700">{{
                        condition.name
                      }}</span>
                    </label>

                    <div class="flex justify-start items-center gap-2 mt-2">
                      <div
                        class="flex border rounded-md overflow-hidden text-xs"
                      >
                        <button
                          (click)="onSeverityChange(condition, condition.severityOptions?.[0] )"
                          [disabled]="!condition.selected"
                          class="px-4 py-3 border-r transition-colors duration-200 line-clamp-2"
                          [ngClass]="{
                            'bg-blue-500 text-white':
                              condition.severity === condition.severityOptions?.[0],
                            'bg-white text-gray-700 hover:bg-gray-100':
                              condition.severity !== condition.severityOptions?.[0],
                            'cursor-not-allowed opacity-50': !condition.selected
                          }"
                        >
                          {{condition.severityOptions?.[0]}}
                        </button>
                        <button
                          (click)="onSeverityChange(condition, condition.severityOptions?.[1])"
                          [disabled]="!condition.selected"
                          class="px-3 py-1 border-r transition-colors duration-200"
                          [ngClass]="{
                            'bg-blue-500 text-white':
                              condition.severity === condition.severityOptions?.[1],
                            'bg-white text-gray-700 hover:bg-gray-100':
                              condition.severity !== condition.severityOptions?.[1],
                            'cursor-not-allowed opacity-50': !condition.selected
                          }"
                        >
                          {{condition.severityOptions?.[1]}}
                        </button>
                        <button
                          (click)="onSeverityChange(condition, condition.severityOptions?.[2])"
                          [disabled]="!condition.selected"
                          class="px-3 py-1 transition-colors duration-200"
                          [ngClass]="{
                            'bg-blue-500 text-white':
                              condition.severity === condition.severityOptions?.[2],
                            'bg-white text-gray-700 hover:bg-gray-100':
                              condition.severity !== condition.severityOptions?.[2],
                            'cursor-not-allowed opacity-50': !condition.selected
                          }"
                        >
                          {{condition.severityOptions?.[2]}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="member.gender === 'Female'"
          class="p-4 border rounded-xl border-gray-200 bg-white"
        >
          <div
            class="flex items-center cursor-pointer"
            (click)="onPregnancyToggle()"
          >
            <label class="text-gray-700 text-base font-medium flex-grow">{{
              pregnancyQuestionInit.label
            }}</label>
            <div
              class="relative inline-flex items-center h-6 rounded-full transition-colors duration-300 ease-in-out"
              [ngClass]="
                isPregnant
                  ? 'bg-blue-600 justify-end'
                  : 'bg-gray-200 justify-start'
              "
              style="width: 56px"
            >
              <span
                class="absolute w-3 h-3 bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out"
                [ngClass]="
                  isPregnant ? 'translate-x-7 left-1' : 'translate-x-1'
                "
              ></span>

              <div class="flex w-full items-center justify-between px-1.5">
                <span
                  class="text-white text-xs font-semibold transition-opacity duration-200 ease-in-out"
                  [ngClass]="isPregnant ? 'opacity-100' : 'opacity-0'"
                >
                  Yes
                </span>

                <span
                  class="text-gray-700 text-xs font-semibold transition-opacity duration-200 ease-in-out"
                  [ngClass]="!isPregnant ? 'opacity-100' : 'opacity-0'"
                >
                  No
                </span>
              </div>
            </div>
          </div>
          <div class="mt-4" *ngIf="isPregnant">
            <div class="flex flex-wrap gap-4 mr-6">
              <div
                *ngFor="let option of pregnancyQuestionInit.options"
                class="flex items-center"
              >
                <input
                  type="radio"
                  id="pregnancy-{{ option }}"
                  [value]="option"
                  name="pregnancy-status"
                  [checked]="pregnancyQuestionInit.selectedValue === option"
                  (change)="onRadioChange(option)"
                  class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                />
                <label
                  for="pregnancy-{{ option }}"
                  class="ml-2 text-sm text-gray-700 whitespace-nowrap"
                  >{{ option }}</label
                >
              </div>
            </div>
            <div class="mt-4">
              <label
                for="due-date"
                class="block text-gray-700 text-sm font-medium mb-2"
                >Expected Delivery Date</label
              >
              <input
                type="date"
                id="due-date"
                [(ngModel)]="pregnancyDueDate"
                class="block w-full p-2 border border-gray-300 rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="p-6 bg-gray-50 border-t rounded-b-xl flex justify-end gap-3">
        <button
          (click)="onClose()"
          class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-3 px-6 rounded-lg shadow-md border border-gray-300"
        >
          Cancel
        </button>
        <button
          (click)="onSave()"
          class="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md"
        >
          Save Health Declaration
        </button>
      </div>
    </div>
  </div>
</div>
